import { AirportResponse } from '../types/api-responses/airport-response'
import { AirportModel } from '../types/models/airport.model'
import { cityResolver } from './city.resolver'

export function airportResolver(airport: AirportResponse): AirportModel
export function airportResolver(airport: AirportResponse[]): AirportModel[]

export function airportResolver(
  airport: AirportResponse | AirportResponse[],
): AirportModel | AirportModel[] {
  if (Array.isArray(airport)) {
    return airport.map(resolveAirport)
  }
  return resolveAirport(airport)
}

function resolveAirport(airport: AirportResponse): AirportModel {
  return {
    address: airport.address,
    latitude: airport.latitude,
    longitude: airport.longitude,
    name: airport.name,
    place_id: airport.place_id,
    city: cityResolver(airport.city),
    types: ['airport'],
  }
}
